import { useEffect, useState, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { PageHeader, Panel } from "../components/Surface";
import { listConnections, acceptConnection, type Connection } from "../lib/connections";

function Row({ children }: { children: ReactNode }) {
  return <li className="flex items-center justify-between border-t border-line py-3 first:border-t-0 first:pt-0">{children}</li>;
}

export function Connections() {
  const [items, setItems] = useState<Connection[]>([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setItems((await listConnections()).connections);
    setLoading(false);
  }
  useEffect(() => {
    void load();
  }, []);

  async function accept(c: Connection) {
    await acceptConnection(c.requester_id);
    await load();
  }

  const incoming = items.filter((c) => c.status === "pending" && c.incoming);
  const accepted = items.filter((c) => c.status === "accepted");
  const outgoing = items.filter((c) => c.status === "pending" && !c.incoming);

  const name = (c: Connection) => <span className="font-bold">{c.other_name}</span>;

  return (
    <div className="grid gap-6">
      <PageHeader
        title="Connections"
        subtitle="Your network of verified operators."
        actions={<Link to="/jobs"><Button variant="ghost">Find people</Button></Link>}
      />

      {loading ? (
        <p className="font-mono text-sm text-muted">Loading…</p>
      ) : (
        <div className="grid gap-6">
          <Panel title={`Requests (${incoming.length})`}>
            {incoming.length === 0 ? (
              <p className="font-mono text-sm text-muted">No pending requests.</p>
            ) : (
              <ul className="grid">
                {incoming.map((c) => (
                  <Row key={c.id}>{name(c)}<Button variant="ghost" onClick={() => accept(c)}>Accept</Button></Row>
                ))}
              </ul>
            )}
          </Panel>

          <Panel title={`Connected (${accepted.length})`}>
            {accepted.length === 0 ? (
              <p className="font-mono text-sm text-muted">No connections yet.</p>
            ) : (
              <ul className="grid">
                {accepted.map((c) => (
                  <Row key={c.id}>{name(c)}<span className="font-mono text-xs text-verified">connected</span></Row>
                ))}
              </ul>
            )}
          </Panel>

          {outgoing.length > 0 && (
            <Panel title={`Sent (${outgoing.length})`}>
              <ul className="grid">
                {outgoing.map((c) => (
                  <Row key={c.id}>{name(c)}<span className="font-mono text-xs text-muted">requested</span></Row>
                ))}
              </ul>
            </Panel>
          )}
        </div>
      )}
    </div>
  );
}
